export default __webpack_public_path__ + "media/images/users/user-sam-kromstain-270x270-a239c89752f0e573f66ff90996365b49.jpg";